'use client'

import { getTheme } from '@/src/constants/buildVariant'
import { Brand } from '@/src/utils/brand'
import { ThemeProvider } from '@/src/ct-design/lib'
import React from 'react'
import { StyleSheetManager } from 'styled-components'

export default function ClientProvider({
    brand,
    children
}: {
    brand: Brand
    children: React.ReactNode
}) {
    return (
        <ThemeProvider theme={getTheme(brand)}>
            <StyleSheetManager>
                {children}
            </StyleSheetManager>
        </ThemeProvider>
    )
}
